<template>

    <footer class="footer">
        <div class="content has-text-centered">
            <p class="level">
                <span class="level-item">
                    <strong class="has-margin-right-small">
                        {{ meta.appName }} v{{ meta.version }}
                    </strong>
                </span>
            </p>
<!--            <p class="level">
                <span class="level-item">
                    <strong>Backed by:</strong>
                    <a href="https://earthlink.ro"
                        target="_blank">
                        <figure class="image earthlink">
                            <img src="https://www.earthlink.ro/images/logos/logo.png">
                        </figure>
                    </a>
                </span>
            </p>
            <p>
                <a href="https://github.com/laravel-enso/enso"
                    target="_blank">
                    <span class="icon">
                        <fa :icon="['fab', 'github']"/>
                    </span>
                </a>
            </p> -->
        </div>
    </footer>

</template>

<script>

import { mapState } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

library.add(faHeart, faGithub);

export default {
    name: 'AppFooter',

    computed: {
        ...mapState(['meta']),
    },
};

</script>

<style lang="scss">

    .footer {
        margin-left: 180px;

        figure.image.earthlink {
            width: 112px;
            margin-left: 1em;
            margin-right: 1em;
        }
    }

    @media screen and (max-width: 1023px) {
        .footer {
            margin-left: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/core/structure/AppFooter.vue